import { useEffect } from "react";
import FaqHome from "app/pages/Faq/FaqHome/FaqHome";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

const FaqHomeContainer = props => {
	const { track } = useAnalytics();

	useEffect(() => {
		track("faq_home_page");
	}, []);

	return <FaqHome {...props} />;
};

FaqHomeContainer.propTypes = {};

export default FaqHomeContainer;
